import { ApiSharingPartnerFormType } from 'components/api-sharing-partners/ApiSharingPartnerForm';

export const createApiSharingPartnerInitialValues: Partial<ApiSharingPartnerFormType> = {
  isActive: true
};
